import { UserOutlined } from '@ant-design/icons'
import { Avatar, Col, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { Pagination } from '../../components'
import { getAllNotifications } from '../../config/getApis'
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux'
import { GeneralActions } from '../../store/actions'

const Notification = (props) => {

    // refresh calls
    const [refresh, setRefresh] = useState(false);
    // notifications array
    const [notifications, setNotifications] = useState([]);
    // filters
    const [filtersParams, setFiltersParams] = useState({
        page: 1,
        perPage: 10,
        total: 0
    })
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch()

    // on arrive of notification screen we set the counter to 0
    useEffect(() => {
        dispatch(GeneralActions.SetNotificationCount(0))
    }, [])

    useEffect(() => {
        let getNotifications = async () => {
            setLoading(true);
            // getAllNotifications function is already handled inside of a try catch block.
            let notifications = await getAllNotifications(filtersParams);
            setNotifications(notifications?.data);
            setFiltersParams({ ...filtersParams, total: notifications?.paginate?.total });
            setLoading(false);
        }
        getNotifications()
    }, [refresh])

    const paginationHandler = (value) => {
        setFiltersParams((prev) => ({ ...prev, page: value }))
        setRefresh(!refresh)
    }

    return (
        <Row gutter={[8, 16]} align={'middle'} justify={'space-between'} className={`${props?.classname} w-full py-4`}>
            <Row align={"middle"} justify={"start"}>
                <h1 className='text-xl font-semibold'>Notifications</h1>
            </Row>
            <div className="w-full flex flex-col gap-4 min-h-[60vh] mt-4">
                {
                    loading ?
                        <div className="flex justify-center items-center w-full py-10"><Spin /></div>
                        :
                        notifications?.length > 0 ?
                            notifications.map((notification, index) => (
                                <div key={notification?.id || index} className='w-full flex items-start gap-4 bg-white rounded-lg p-4 cursor-pointer shadow-sm border border-gray-100'>
                                    <div className='flex-shrink-0'>
                                        {
                                            notification?.url ?
                                                <Avatar src={notification.url} size={55} /> :
                                                <Avatar icon={<UserOutlined />} size={55} />
                                        }
                                    </div>
                                    <div className='flex flex-col gap-1 min-w-0 flex-1'>
                                        <p className='text-[#4b5563] m-0 text-[15px] leading-snug'>{notification?.body ? notification?.body : '-'}</p>
                                        <small className="text-gray-400 mt-1">{dayjs(notification?.createdAt).format("D MMMM YYYY - h:mmA")}</small>
                                    </div>
                                </div>
                            ))
                            :
                            <p className="text-center w-full text-gray-500 py-10">No Notifications Available</p>
                }
            </div>

            {/* pagintation */}
            {
                !loading && notifications?.length > 0 &&
                <Row className='flex items-center justify-center w-full'>
                    <Pagination.Basic
                        total={filtersParams.total}
                        current={filtersParams.page}
                        pageSize={filtersParams.perPage}
                        onChange={paginationHandler}
                    />
                </Row>
            }
        </Row>
    )
}

export default Notification